import { useMemo } from 'react';
import { Landmark } from 'lucide-react';
import { t } from '@lingui/core/macro';

import { MultipleChoiceFilter } from '@duke-hq/ui/components/MultipleChoice/MultipleChoiceFilter';
import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { iconSize } from '@duke-hq/ui/constants/scalable';

export default function ProvidersFilter({ maxSelected }: { maxSelected?: number }) {
  const { updateFilters, filters } = useFiltersContext();
  const { data: providers } = trpcAdmin.providers.all.useQuery({});

  const options = useMemo(() => {
    return (providers ?? [])
      .map(({ id, name }) => ({
        id: id.toString(),
        value: id.toString(),
        label: name,
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [providers]);

  const selected = filters.providerIds ?? [];

  if (options.length === 0) {
    return null;
  }

  return (
    <MultipleChoiceFilter
      items={options}
      label={t`Provider`}
      name="providerIds"
      value={selected.join(',')}
      onFilterChange={({ providerIds }) => updateFilters({ providerIds })}
      onlyUpdateOnChange
      variant="ghost"
      leftIcon={<Landmark size={iconSize.md} />}
      rightIcon={undefined}
      maxSelected={maxSelected}
    />
  );
}
